import { DemandValidation } from 'constants/DemandValidation';
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";

export const getUncompletedSectionsForApproval = (demandValidation = []) => doFilterSections(demandValidation, [DemandValidation.APPROVAL])

export default (demandValidation = []) => doFilterSections(demandValidation, [])

const doFilterSections = (demandValidation = [], additionalExcludedSections = []) => {
	return demandValidation.reduce( (acc, item) => {
		if (item.section === DemandValidation.PUBLICATION || item.section === DemandValidation.EX_POST_GO_TO_FINISH) return acc;
		if (additionalExcludedSections.some(x => item.section === x)) return acc;
		if (item.status === DemandValidationSectionStatus.UNAVAILABLE) return acc;
		if ((item.required && item.status !== DemandValidationSectionStatus.OK) || item.status === DemandValidationSectionStatus.ERROR) return [
			...acc,
			item.section
		]
		return acc;
	}, [])
}